import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useState } from 'react';
import { resolveErrorMessage } from '@paysera/error-message-resolver';
import { loggerFactory } from 'paysera-logger';
import useCancelablePromise from "./useCancelablePromise";
import useLoaderState from "./useLoaderState";
import { isCanceledPromise } from "../service/cancelablePromiseManager";
var useAct = function useAct(action, errorHandler, errorMessageConfig) {
  var _useCancelablePromise = useCancelablePromise(),
    addCancelablePromise = _useCancelablePromise.addCancelablePromise;
  var _useLoaderState = useLoaderState(true),
    isLoaded = _useLoaderState.isLoaded,
    start = _useLoaderState.start,
    stop = _useLoaderState.stop;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    result = _useState2[0],
    setResult = _useState2[1];
  var act = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var resolver,
        resolverResult,
        errorMessage,
        _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            start();
            resolver = addCancelablePromise(Promise.resolve(action.apply(void 0, _args)));
            _context.next = 5;
            return resolver;
          case 5:
            resolverResult = _context.sent;
            _context.t0 = setResult;
            _context.next = 9;
            return resolver;
          case 9:
            _context.t1 = _context.sent;
            (0, _context.t0)(_context.t1);
            errorHandler.clearError();
            return _context.abrupt("return", resolverResult);
          case 15:
            _context.prev = 15;
            _context.t2 = _context["catch"](0);
            if (isCanceledPromise(_context.t2)) {
              loggerFactory('use-act').captureException(new Error("Act shouldn't be canceled"));
            }
            _context.t3 = resolveErrorMessage;
            _context.t4 = _context.t2;
            _context.next = 22;
            return errorMessageConfig;
          case 22:
            _context.t5 = _context.sent;
            _context.next = 25;
            return (0, _context.t3)(_context.t4, _context.t5);
          case 25:
            errorMessage = _context.sent;
            errorHandler.dispatchError(errorMessage, _context.t2);
          case 27:
            _context.prev = 27;
            stop();
            return _context.finish(27);
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 15, 27, 30]]);
    }));
    return function act() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    loaded: isLoaded(),
    result: result,
    act: act
  };
};
export default useAct;